import React from "react";
import "./card.css";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

//import Typography from '@material-ui/core/Typography';
// const useStyles = makeStyles({
//     root: {
//         display: 'flex',
//         flexWrap: 'wrap',
//         justifyContent: 'space-around',
//         overflow: 'hidden',

//       },

//   });

const EachOut = props => {
  let flagv = 0;
  let type;
  for (let i = 0; i < props.details.tags.length; i++) {
    if (props.details.tags[i] === "Veg") flagv = 1;
  }

  if (flagv === 1) type = "Veg Only";
  else type = "Veg & NonVeg";

  // const classes = useStyles();

  return (
    <Card style={{ height: 200 }} className="crd" raised={true}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid
            item
            xs={4}
            style={{
              backgroundColor: "#F1F1F1",
              textAlign: "center",
              position: "relative",
              height: 200,
              overflowWrap: "break-word"
            }}
          >
            <Typography
              variant="body1"
              style={{ fontWeight: "bold" }}
              color="textSecondary"
            >
              {props.statC}
            </Typography>

            <Typography
              variant="body1"
              style={{ fontWeight: "bold" }}
              color="textSecondary"
            >
              {props.statN}
            </Typography>

            <br />

            <div style={{ position: "absolute", bottom: 20, marginLeft: 10 }}>
              <Typography variant="body1" color="textSecondary">
                {"Day " + props.day}
              </Typography>

              <Typography variant="body1" color="textSecondary">
                {"SCH " + props.sch}
              </Typography>
            </div>
          </Grid>

          <Grid item xs={8} style={{ position: "relative" }}>
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="body1">
                  {props.details.outletName}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" color="textSecondary">
                  {props.details.openingTime + "-" + props.details.closingTime}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" color="textSecondary">
                  {type}
                </Typography>
              </Grid>
            </Grid>

            {/* <div style={{ marginTop: 2 }}>
              <Typography variant="body1" color="textSecondary" align="center">
                {type}
              </Typography>
            </div> */}

            <Grid
              container
              spacing={2}
              style={{ position: "absolute", bottom: 20 }}
            >
              {/* <Grid item xs={12}>
                <Divider />
              </Grid> */}
              <Grid item xs={6}>
                Order Before
                <Typography variant="body1" color="textSecondary">
                  {props.details.order_timing + "minutes"}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                Min. Order
                <Typography variant="body1" color="textSecondary">
                  {props.details.minOrderAmount}
                </Typography>
              </Grid>
            </Grid>

            {/* <p>Order Before
   <Typography variant="body1" color="textSecondary">
          { props.details.order_timing +"minutes"} 
      </Typography>   

  Min.Order 
   <Typography variant="body1" color="textSecondary">
               {props.details.minOrderAmount}
      </Typography>  

       </p>   */}

            {/* <ul style={{  listStyleType:"none"}}>
            <li>  {props.details.outletName}      </li>
            <li>   {props.details.openingTime +"-" + props.details.closingTime}     </li>
            <li>   {type}  </li>
            <li>  {"Order Before "+props.details.order_timing +"minutes"}  </li>
            <li>   {"Min.Order " +props.details.minOrderAmount}     </li>
          

         
            
           </ul> */}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
export default EachOut;
